import { RootState } from '@store';

export const selectVehicleStock = (state: RootState) => {
  return state.vehicleStock?.vehicleStock;
};

export const selectSelectedVehicleStock = (state: RootState) => {
  return state.vehicleStock?.selectedVehicleStock;
};

export const selectSelectedVehicleStockStatus = (state: RootState) => {
  return state.vehicleStock?.selectedVehicleStockStatus;
};
